import { LocationStrategy } from '@angular/common';
import { Params, Router, UrlTree } from '@angular/router';

import { NotificationLink } from './notification.model';

// TODO move higher up the hierarchy
// TODO revise. consider using NavigationBehaviorOptions.state after upgrade
export enum NavigationSrc {
    NOTIFICATION = 'notification',
    NOTIFICATION_ALERT = 'notification-alert',
}

// TODO move higher up the hierarchy
// TODO revise. consider using NavigationBehaviorOptions.state after upgrade
export const NavigationSrcQueryParam = '_src';

// maybe di this from each module
const nonWebFormLinks: RegExp[] = [
    // see coaching navigate (don't want to import from there)
    /^\/coaching-detail\/\d+\/(observation|commitment|commitments|draftcommitments)(\?|\/|$)/i,
];

export function navigateForLink(
    locationStrategy: LocationStrategy,
    router: Router,
    link: NotificationLink,
    src: NavigationSrc,
    newTab: boolean,
): void {
    if (!link || !link.url) {
        return;
    }

    let urlTree: UrlTree;

    if (nonWebFormLinks.some((e) => e.test(link.url))) {
        urlTree = router.parseUrl(link.url);
        urlTree.queryParams[NavigationSrcQueryParam] =
            src || NavigationSrc.NOTIFICATION;
    } else {
        const queryParams: Params = {
            relativeUrl: link.url,
        };
        queryParams[NavigationSrcQueryParam] =
            src || NavigationSrc.NOTIFICATION;

        urlTree = router.createUrlTree(['internal', 'webform'], {
            queryParams,
        });
    }

    if (!newTab) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        router.navigateByUrl(urlTree);
    } else {
        const baseHref = locationStrategy.getBaseHref();
        const url = `${baseHref}${urlTree.toString()}`.replace(/\/\//g, '/');
        window.open(url, '_blank');
    }
}
